// extracted by mini-css-extract-plugin
export default {"root":"CaseLabel_root__kQvR7","name":"CaseLabel_name__YKdJN"};